module.exports = __webpack_public_path__ + "img/btn_zoom_in.c21812a9.svg";